import axios from 'axios';
import { QueryParameterType } from '@/composables/state/dataDownloadSearchApp';

if (!import.meta.env.VITE_APP_DATA_PORTAL_INFO_URL) {
  throw new Error('ABMI API Env not set: VITE_APP_HOME_URL');
}

const abmiApiUrl = import.meta.env.VITE_APP_DATA_PORTAL_INFO_URL;

const abmiAxios = axios.create({
  baseURL: abmiApiUrl
});

// https://web-dev-2021.abmi.ca/.rest/website/?media[null]=false&hideInNav=false&orderBy=postDate%20desc&@ancestor=/abmi-home/connect/media-story-hub/data&limit=8
/* get all media, and do counting */

export async function getDatasetTags () {
  const apiFct = 'get-tags';
  try {
    const response = await abmiAxios.get(apiFct, { params: { rootPath: '/open-data-portal' } });
    const data = response.data;
    // console.log('get-tags');
    // console.log(data.dataType);
    return data;
  } catch (error) {
    return (error);
  }
}

export async function searchDatasets (inParams:QueryParameterType) {
  const apiFct = '/query-data';
  const params = { ...inParams };
  if (params.searchText && params.searchText.length > 0) {
    params.searchKey = [params.searchText];
  }
  try {
    const response = await abmiAxios.get(apiFct, { params });
    const data = response.data;
    return data;
  } catch (error) {
    return (error);
  }
}

const abmiApi = {
  searchDatasets
};

export default abmiApi;
